import useBootstrapData from '@/hooks/useBootstrapData'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import useSeti from '@/hooks/useSeti'
import pclnExperimentation from '@pcln/experimentation'
import hasRecentSearchFlightData from '../helper/hasRecentSearchFlightData'

export default function useGetMostRecentFlightSearch() {
  const {
    webstats: { clientGUID },
    appName,
    appVersion
  } = useBootstrapData()

  const fightsLPTripActivityBundlesExperiment = useSeti(
    'FLIGHT_LP_TRIPACTIVITY_BUNDLES',
    false
  )

  const isDefault = fightsLPTripActivityBundlesExperiment === 'DEFAULT'

  const mostRecentFlightSearchData = useRecentSearchCard(
    clientGUID,
    { appName, appVersion },
    ['FLY'],
    isDefault
  )

  if (isDefault || !hasRecentSearchFlightData(mostRecentFlightSearchData)) {
    return []
  }

  pclnExperimentation.fireImpression('FLIGHT_LP_TRIPACTIVITY_BUNDLES')

  return mostRecentFlightSearchData
}
